import React from "react"
import Container from "@ecom/ui/components/Container"
import { AppLink } from "@ecom/ui/components/AppLink"
import * as styles from "./stepsTitle.module.scss"

export default function StepsTitle() {
  return (
    <Container>
      <div className={styles.container}>
        <h1 className={styles.title}>Улучшение кредитной истории!</h1>
        <p className={styles.desc}>
          Подключите один из пакетов. Каждый из них даёт возможность улучшения кредитной истории
          и&nbsp;дополнительно содержит программу защиты жизни, здоровья, имущества, потери дохода
          комплексную ИТ-защиту и{" "}
          <AppLink
            href="https://sovcombank.ru/solutions/private/ispravlenie-oshibok-v-kreditnoi-istorii"
            target="_blank" rel="noreferrer"
          >
            доступ к сервису исправления ошибок в кредитных отчетах в БКИ
          </AppLink>{" "}
          сроком на 1 год.
          <br />
        </p>
      </div>
    </Container>
  )
}
